export default __webpack_public_path__ + "static/media/bpb-pembelian-barang.40da0b26.png";